<template>
    <div class="flat-detailed" v-if="apartment">
        <h1 @click="$router.go(-1)" class="text title flat-detailed__title flex items-center cursor-pointer">
            <svg>
                <use xlink:href="../../../images/sprite.svg#direction-arrow"/>
            </svg>
            <span>Характеристика</span>
        </h1>
        <div class="flat-detailed__chosen flat-chosen flex">
            <div>
                <div class="flat-chosen__plan mobile-only">
                    <picture>
<!--                        <source srcset="/images/purchase/flat-scheme-mobile.png, /images/purchase/flat-scheme-mobile2x.png 2x" type="png">-->
                      <img v-if="apartment.image" :src="apartment.image" alt="План квартиры">
                    </picture>
                </div>
                <h2 class="flat-detailed__subtitle flat-chosen__description _uppercase">{{apartment.bedrooms}}<span v-if="apartment.bedrooms > 1">-x</span> комн. &#8470; квартиры &nbsp;{{apartment.number}}</h2>
                <a href="/contacts">
                    <div class="flat-chosen__book text _x-bold _uppercase mobile-only">Забронировать</div>
                </a>
<!--                <div class="flat-chosen__view mobile-only flex items-center cursor-pointer" @click="showWindowView = true">-->
<!--                    <span class="text _x-bold _uppercase">Вид из окна</span>-->
<!--                    <svg>-->
<!--                        <use xlink:href="../../../images/sprite.svg#eye"/>-->
<!--                    </svg>-->
<!--                </div>-->
                <div class="flex desktop-only flat-chosen__actions space-between items-start">
                    <a href="/contacts">
                        <div class="flat-chosen__book text _x-bold _uppercase">Забронировать</div>
                    </a>
<!--                    <div class="flat-chosen__view flex items-center cursor-pointer" @click="showWindowView = true">-->
<!--                        <span class="text _x-bold _uppercase">Вид из окна</span>-->
<!--                        <svg>-->
<!--                            <use xlink:href="../../../images/sprite.svg#eye"/>-->
<!--                        </svg>-->
<!--                    </div>-->
                </div>
                <div class="flat-chosen__advantages flex flex-col">
                    <span class="text">Общая площадь&nbsp;&mdash; {{apartment.area}}&nbsp;м&sup2;</span>
                    <span class="text">Количество комнат&nbsp;&mdash; {{apartment.bedrooms}}</span>
                </div>
                <div class="flat-chosen__price flat-detailed__subtitle _uppercase">{{apartment.price.toString().indexOf('.') > -1 ? apartment.price.split('.')[0] : apartment.price}} Р</div>
                <div class="flex flex-col">
                    <a class="flat-chosen__link _uppercase text _x-bold" href="/purchase-terms">Рассчитать ипотеку</a>
                    <loading :active.sync="isLoading"
                             :can-cancel="false"
                             :is-full-page="fullPage"></loading>
                    <form class="flat-chosen__link _uppercase text _x-bold flex items-center cursor-pointer" @submit.prevent="showPresentation" >
                        <input type="submit" style="display: none" id="presentation">
                        <label for="presentation" class="cursor-pointer">
                          Презентация
                          <svg>
                              <use xlink:href="../../../images/sprite.svg#arrow"/>
                          </svg>
                        </label>
                    </form>
                </div>
            </div>
            <div class="flex flex-col flat-chosen__options desktop-only">
                <div class="flex items-center flat-control">
                    <div class="flat-control__data flat-control-data flex flex-col items-center">
                        <div class="flat-control-data__number">{{apartment.floor_number}}</div>
                        <span class="flat-control-data__text text">этаж</span>
                    </div>
                </div>
                <div class="flex items-center flat-control">
                    <div class="flat-control__data flat-control-data flex flex-col items-center">
                        <div class="flat-control-data__number">{{apartment.number}}</div>
                        <span class="flat-control-data__text text">квартира</span>
                    </div>
                </div>
                <div class="flex items-center flat-control">
                    <div class="flat-control__data flat-control-data flex flex-col items-center">
                        <div class="flat-control-data__number">{{apartment.area}}<span class="_metres">м<sup>2</sup></span></div>
                        <span class="flat-control-data__text text">площадь</span>
                    </div>
                </div>
            </div>
            <div class="flat-chosen__scheme desktop-only">
              <picture>
<!--                <source media="(min-width: 1024px)" srcset="/images/purchase/flat-scheme-desktop.png 1x, /images/purchase/flat-scheme-desktop2x.png 2x, /images/purchase/flat-scheme-desktop@3x.png 3x">-->
                <img v-if="apartment.image" :src="apartment.image" alt="План квартиры">
<!--                <img src="/images/purchase/flat-scheme-desktop.png" srcset="/images/purchase/flat-scheme-desktop@2x.png 2x">-->
              </picture>
            </div>
        </div>

        <section class="recommend">
          <div class="recommend__box">

              <div class="recommend__title _finish _bold">Рекомендуем</div>
              <div class="recommend__row">

<!--          <swiper class="swiper" :options="swiperOption">-->
<!--              <swiper-slide class="slider-views__slide"-->
<!--                   v-for="slide in slides" :key="slide.id"-->
<!--              >-->
<!--                  <img :src="slide.src" alt="">-->
<!--              </swiper-slide>-->
<!--          </swiper>-->

                <swiper ref="swiperParent" class="swiper recommend__swiper-container" :options="swiperOption">

                  <swiper-slide class="swiper-slide recommend__slide"
                    v-for="slide in slides" :key="slide.ID"
                  >
                    <recommend-item
                      :slider="slide.SLIDER"
                      :name="slide.NAME"
                      :code="slide.CODE"
                      :url="slide.URL"
                      :type="slide.PROPERTY_TYPE"
                    ></recommend-item>

                  </swiper-slide>
                </swiper>
                <div class="recommend-btns" v-if="slidesLength > 4 && window.innerWidth > 1024">
                    <div class="recommend-btn recommend-btn-prev js-recommendSliderBtnPrev" slot="button-prev" @click="swiperParent.slidePrev(500)">
                        <img src="/images/recommend/recommend-prev.svg" alt="">
                    </div>
                    <div class="recommend-btn recommend-btn-next js-recommendSliderBtnNext" slot="button-next" @click="swiperParent.slideNext(500)">
                        <img src="/images/recommend/recommend-next.svg" alt="">
                    </div>
                </div>




              </div>

          </div>
        </section>

<!--        <Popup v-show="showWindowView"-->
<!--             @close="showWindowView=false"-->
<!--             title="Вид из окна"-->
<!--        >-->
<!--        <template v-slot:body>-->
<!--          <swiper class="swiper" :options="swiperOption">-->
<!--              <swiper-slide class="slider-views__slide"-->
<!--                   v-for="slide in slides" :key="slide.id"-->
<!--              >-->
<!--                  <img :src="slide.src" alt="">-->
<!--              </swiper-slide>-->
<!--          </swiper>-->
<!--        </template>-->
<!--        <template v-slot:footer>-->
<!--        </template>-->
<!--      </Popup>-->
      <div id="floor-plan" class="selected-floor" ref="floor-plan"></div>
    </div>
</template>
<script>
    import Popup from "../components/Popup";
    import RecommendItem from "../components/RecommendItem";
    import Loading from 'vue-loading-overlay';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
      components: {Popup, Swiper, SwiperSlide, Loading, RecommendItem},
      data() {
            return {
              isLoading: false,
              fullPage: true,
              swiperOption: {
                // slidesPerView: 4,
                // spaceBetween: 36,
                slidesPerView: 1,
                spaceBetween: 0,
                // pagination: {
                //   el: '.swiper-pagination'
                // },
                navigation: {
                  nextEl: '.js-recommendSliderBtnNext',
                  prevEl: '.js-recommendSliderBtnPrev',
                },
                observer: true,
                observeSlideChildren: true,
                observeParents: true,
                // allowTouchMove: false,
                breakpoints: {
                  // 240: {
                  //   slidesPerView: 4,
                  //   spaceBetween: 36,
                  // },
                  1024: {
                    // slidesPerView: 2,
                    slidesPerView: 4,
                    spaceBetween: 36,
                  }
                },
              },
              swiperSmallOption: {
                slidesPerView: 1,
                spaceBetween: 10,
                // pagination: {
                //   el: '.swiper-pagination'
                // },
                // navigation: {
                //   nextEl: '.js-recommendSliderBtnNext',
                //   prevEl: '.js-recommendSliderBtnPrev',
                // },
                observer: true,
                observeSlideChildren: true,
                observeParents: true,
                allowTouchMove: false,
              },
              apartment: null,
              floor: 15,
              flat: 15,
              area: 142,
              showWindowView: false,
              slides: null,
              slidesLength: null,
              selectedBuildingFloor: null,
              selectedFloorAvailableApartments: null,
              presentationLink: null
            }
        },
        computed: {
          swiperParent() {
            return this.$refs.swiperParent.$swiper
          }
        },
        async mounted() {
          await axios.get('/apartments/'+this.$route.params.number)
              .then(response => {
                  this.apartment = response.data.data
              }, this);
          await axios.get('/api/', {
                params: {
                  token: 'z1x2dFg9Xa',
                  Method: 'GetSortedObjectList',
                  code: '["tricolor","litsa","oko","head-liner"]'
                },
                auth: {
                    username: 'apache',
                    password: 'aema0ohvei0Ye_Jaitoh'
                }
              })
              .then(response => {
                  const projects = response.data.OBJECT

                  const convertPriceFlat =  parseFloat(this.apartment.price.split(' ').join('')) / 1000000

                  this.slides = projects.filter(function(item) {
                      if(convertPriceFlat >= (parseFloat(item.PRICE_FROM) - 10) && convertPriceFlat <= (parseFloat(item.PRICE_TO) + 10)) {
                          return item
                      }
                  })
                  this.slidesLength = this.slides.length
              }, this)
              .catch(err => {
                  return err
              })
          ;
          await axios.get('/buildings')
             .then(async(response) => {
                let buildings = await response.data.data;
                let selectedBuilding = await buildings.find(building => building.number === this.apartment.building_number)
                this.selectedBuildingFloor = await selectedBuilding.floors.find(floor => floor.number === this.apartment.floor_number);
                this.selectedFloorAvailableApartments = await this.selectedBuildingFloor.apartments.filter(apartment => apartment.status === 'available')
                await this.addFloorPlan(this.selectedBuildingFloor.image)
                .then(val => {
                  // console.log('--val',val)
                  this.getFloorImageUrl();
                })

              }, this)


        },
        methods: {
          showPresentation() {
            if(this.floorImageUrl !== null) {
              this.isLoading = true;
              var newWindow = window.open('about:blank', '_blank'); // v1
              // var newWindow = window.open(); // v2
              axios.post(`/flat-pdf/${this.apartment.id}`, {
                image: this.floorImageUrl
              }).then((res) => {
                  newWindow.location = `/storage/presentations/presentation-apartment${this.apartment.id}.pdf`; // v1
                  // newWindow.document.write(res.data.presentation); // v2
              //   window.open(res.data.presentation, '_blank'); //source
                this.isLoading = false;
              }).catch(() => {
                this.isLoading = false;
              })
            }
          }
        }

    }
</script>
<style lang="scss">
    @import '../../../sass/variables';

    .selected-floor {
      position: absolute;
      left: -9999px;
      z-index: -1;
      /*width: 40rem;*/
      /*height: auto;*/

      & svg {
        width: 968px;
        height: 934px;

      }
    }

    .flat {
        &-detailed {
          position: relative;
          z-index: 1;
          background: $sand;
          padding-top: 6rem;

            .slider-views__slide {
                width: 15rem;
                & img {
                  width: 100%;
                  height: auto;
                }
            }

            @media (min-width: $desktop-min-width) {
                margin: 8rem 14rem 0;
                padding-top: 0;
            }

            &__title {
                margin-top: 3.4rem;
                margin-left: 2.4rem;
                margin-bottom: 3.4rem;

                letter-spacing: 0.07em;
                font-weight: 700;

                @media (min-width: $desktop-min-width) {
                    margin-left: 0;
                    margin-top: 0;
                    margin-bottom: 5.4rem;
                }

                & svg {
                    transform: rotate(180deg);
                    margin-right: 2.6rem;
                    width: 1.8rem;
                    height: 1.8rem;
                }
            }

            &__subtitle {
                margin-bottom: 4.6rem;

                font-size: 2.4rem;
                letter-spacing: 0.07em;
                line-height: 1.5;
                font-weight: 700;
            }
        }

        &-chosen {
            margin-top: 4.6rem;
            margin-bottom: 0;
            padding-left: 3.3rem;
            padding-right: 3.3rem;
            background-color: #FFFBF8;

            @media (min-width: $desktop-min-width) {
                margin-top: 9.8rem;
                padding-bottom: 0;
                margin-bottom: 0;
                padding-left: 0;
                padding-right: 0;
            }

            &__plan {
                margin-bottom: 4.9rem;

                & img {
                    width: 31rem;
                    margin: 0 auto;
                }
            }

            &__description {
                width: 22rem;
                margin-bottom: 3.2rem;

                @media (min-width: $desktop-min-width) {
                    width: 100%;
                }
            }

            &__book {
                position: relative;
                margin-bottom: 3.5rem;
                color: $hypertext;
                letter-spacing: 0.16em;
                background: transparent;
                border: none;

                &::after {
                    content: '';

                    position: absolute;

                    left: 0;
                    bottom: -1.6rem;

                    width: 8.8rem;
                    height:0.1rem;

                    background: $hypertext;
                }

                @media (min-width: $desktop-min-width) {
                    margin-bottom: 0;
                }
            }

            &__view {
                margin-bottom: 1.9rem;

                letter-spacing: 0.16em;

                & svg {
                    margin-left: 1.6rem;
                    width: 1.6rem;
                    height: 1.6rem;
                }
            }

            &__actions {
                width: 41.6rem;
                margin-bottom: 2.7rem;
            }

            &__advantages {
                margin-bottom: 6.4rem;
                & .text {
                    margin-bottom: 0.3rem;
                }
            }

            &__price {
                margin-bottom: 2.8rem;
            }

            &__link {
                margin-bottom: 2.4rem;
                display: inline-block;

                letter-spacing: 0.16em;
                text-decoration: none;

                & svg {
                    width: 1.2rem;
                    height: 1.2rem;
                    margin-left: 1.6rem
                }
            }

            &__options {
                margin-left: 8.8rem;
                align-items: center;
                & .flat-control {
                    margin-bottom: 8.8rem;

                    &__btn {
                        background: transparent;
                        border: none;
                        outline: none;

                        &._up {
                            transform: rotate(0deg);
                            margin-left: 2rem;

                            & svg {
                                width: 0.4rem;
                                height: 1rem;
                            }
                        }


                        &._down {
                            transform: rotate(180deg);
                            margin-right: 2rem;

                            & svg {
                                width: 0.4rem;
                                height: 1rem;
                            }
                        }
                    }

                    &-data {
                        min-width: 10.4rem;

                        &__number {
                            margin-bottom: 0.7rem;
                            font-size: 3.8rem;
                            line-height: 1.5;
                            font-weight: 800;
                            letter-spacing: 0.07em;

                            & ._metres {
                                font-weight: 400;
                                font-size: 1.6rem;
                            }
                        }
                    }
                }
            }

            &__scheme {
                margin-left: 5rem;

                & img {
                    width: 48rem;
                    //height: 34.1rem;
                }
            }
        }
    }
  .relative.flat [zanyato],.relative.flat .x00001 {
      fill: rgba(0,0,0,0.7) !important;
  }
  .relative.flat [svobodno],.relative.flat .x00001 {
      fill: #CF5607 !important;
  }

.recommend {
    position: relative;
    padding-top: 0.7rem;
    padding-bottom: 4.5rem;
    overflow: hidden;

    @media (max-width: $mobile-max-width) {
      padding-left: 3.3rem;
      padding-right: 3.3rem;
      padding-top: 5rem;
    }

    &__title {
      font-style: normal;
      font-size: 3.6rem;
      letter-spacing: 0.06em;
      line-height: 1.5;
      font-weight: 700;
      color: #000000;
      text-transform: uppercase;
      margin-bottom: 3.9rem;

      @media (max-width: $mobile-max-width) {
        font-size: 2.35rem;
        letter-spacing: 0;
        margin-bottom: 3.8rem;
      }
    }

    &__box {
        width: 100%;
        padding: 0;
        margin: 0 auto;
        position: relative;
    }
    &__swiper-container {
      width: 100%;

      @media (max-width: $mobile-max-width) {
        overflow: visible;
      }
    }
    &__row {
      @media (max-width: $mobile-max-width) {
        padding-right: 3rem;
      }
    }
    &__col {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
           -moz-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
      &:not(:last-child) {
          margin-right: 51px;
      }
    }
    .swiper-wrapper {
        -webkit-box-sizing: content-box;
           -moz-box-sizing: content-box;
                box-sizing: content-box;
    }

}

.recommend-btns {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
       -moz-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
       -moz-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    width: 100%;
    padding-top: 1.6rem;
    text-align: center;
    position: relative;
    top:auto;
    left: auto;
    right: auto;
    bottom:auto;

    @media (max-width: $mobile-max-width) {
        width: auto;
        margin-right: -3rem;
        padding-top: 0;
    }
}

.recommend-btn {
    display: inline-block;
    line-height: 1;
    cursor: pointer;
    position: relative;
    -webkit-border-radius: 2.5rem;
       -moz-border-radius: 2.5rem;
            border-radius: 2.5rem;
    overflow: hidden;
    -webkit-transition: opacity 0.2s ease;
    -o-transition: opacity 0.2s ease;
    -moz-transition: opacity 0.2s ease;
    transition: opacity 0.2s ease;
    min-width: 5rem;
    width: 5rem;
    height: 5rem;
}

.recommend-btn-prev {
    margin-right: 1rem;
}

.recommend-btn.swiper-button-disabled {
    cursor: default;
    opacity: 0.6;
}

.swiper-slide.recommend__slide {
    display: flex;
}

.appart-photo {
    display: block;
    position: relative;
    width: 100%;
    padding-bottom: 76%;
    height: auto;
    background-position: center;
    background-repeat: no-repeat;
    -webkit-background-size: cover;
       -moz-background-size: cover;
         -o-background-size: cover;
            background-size: cover;

}

.appart-photo-pagination {
    position: absolute;
    bottom: 16px;
    left: 0;
    width: 100%;
    height: auto;
    top: auto;
    /* line-height: 1; */
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
       -moz-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
       -moz-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    z-index: 1;
}
.swiper-container-horizontal>.swiper-pagination-bullets.appart-photo-pagination {
    bottom: 16px;
}
.appart-photo-pagination .swiper-pagination-bullet {
    opacity: 1;
    background-color: #ffffff;
    -webkit-transition: background-color 0.2s 0s;
    -o-transition: background-color 0.2s 0s;
    -moz-transition: background-color 0.2s 0s;
    transition: background-color 0.2s 0s;
    margin: 0 5px;
}
.appart-photo-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1;
    background-color: #326664;
}
</style>
